module.exports = __webpack_public_path__ + "img/detail2.38d29b5e.png";